import { createSelector } from 'reselect';
const mapSettings = (state, props) => {
  var _state$settings$setti, _cabinet$client;
  const {
    cabinetIdentifier
  } = props;
  const cabinet = (_state$settings$setti = state.settings.settings.cabinetDefinitions) === null || _state$settings$setti === void 0 ? void 0 : _state$settings$setti.find(cd => cd.identifier === cabinetIdentifier);
  if (!cabinet) return {
    pinStyles: {},
    calloutSize: {},
    calloutLayouts: {}
  };
  const mapView = cabinet === null || cabinet === void 0 || (_cabinet$client = cabinet.client) === null || _cabinet$client === void 0 || (_cabinet$client = _cabinet$client.web) === null || _cabinet$client === void 0 || (_cabinet$client = _cabinet$client.views) === null || _cabinet$client === void 0 ? void 0 : _cabinet$client.find(view => view.title === 'Map');
  let mapViewEnabled = false;
  const mapDefinition = mapView === null || mapView === void 0 ? void 0 : mapView.mapDefinition;
  if (mapDefinition) {
    mapViewEnabled = true;
  } else {
    return {
      pinStyles: {},
      calloutSize: {},
      calloutLayouts: {}
    };
  }
  const {
    defaultMapType = 'standard',
    rotateEnabled,
    scrollEnabled,
    showsCompass,
    showsScale,
    showsUserLocation,
    showsUserLocationControl,
    zoomEnabled
  } = mapDefinition;
  const pinStyles = {};
  let calloutSize = {};
  const calloutLayouts = {};
  mapDefinition.layers.forEach(layer => {
    var _layer$pointDefinitio;
    const formTypeIdentifiers = ((_layer$pointDefinitio = layer.pointDefinition) === null || _layer$pointDefinitio === void 0 ? void 0 : _layer$pointDefinitio.formTypeIdentifiers) || [];
    if (!formTypeIdentifiers.length) return;
    const {
      callout,
      style
    } = (layer === null || layer === void 0 ? void 0 : layer.pointDefinition) || {};
    if (callout !== null && callout !== void 0 && callout.size) {
      calloutSize = callout.size;
    }
    formTypeIdentifiers.forEach(formType => {
      if (callout !== null && callout !== void 0 && callout.layout) {
        const layout = callout.layout[formType] || null;
        if (layout) {
          calloutLayouts[formType] = layout;
        }
      }
      if (style) {
        pinStyles[formType] = style[formType] || null;
      }
    });
  });
  return {
    calloutSize,
    calloutLayouts,
    defaultMapType,
    mapViewEnabled,
    pinStyles,
    rotateEnabled,
    scrollEnabled,
    showsCompass,
    showsScale,
    showsUserLocation,
    showsUserLocationControl,
    zoomEnabled
  };
};
export default createSelector([mapSettings], settings => settings);